import OrderSimpleForm from './OrderSimpleForm'

export default OrderSimpleForm
